import { render, staticRenderFns } from "./OrderSearchTableConfig.vue?vue&type=template&id=3f549dc3&scoped=true"
import script from "./OrderSearchTableConfig.vue?vue&type=script&lang=js"
export * from "./OrderSearchTableConfig.vue?vue&type=script&lang=js"
import style0 from "./OrderSearchTableConfig.vue?vue&type=style&index=0&id=3f549dc3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f549dc3",
  null
  
)

export default component.exports